export const FRAME_HEIGHTS = ["16rem", "24rem", "32rem"];
export const PHOTO_HEIGHTS = ["14rem", "21rem", "28rem"];
export const ADJECTIVES_TAG = "adjectives";
